













import { defineComponent } from '@vue/composition-api';
import siteHeader from '@front-app/components/header/Header.vue';
import BasePage from '@front-app/components/layouts/BasePage.vue';
import TabBar from '@front-app/components/tabBar/TabBar.vue';

export default defineComponent({
	components: {
		siteHeader,
		BasePage,
		TabBar,
	},
	props: {
		myTimedRightUrl: {
			type: String,
			default: '',
		},
	},
});
